import React from 'react';

interface IframeGuardProps {
  children: React.ReactNode;
}

export const IframeGuard: React.FC<IframeGuardProps> = ({ children }) => {
  const isInIframe = window.top !== window.self;

  if (!isInIframe) {
    window.location.replace(`${window.origin}/notfound`);
    return null;
  }

  return children as React.ReactElement;
};

// export const IframeGuard = () => {};
